export interface RoutingMixin {
  pushState(state: any, title: string, url?: string): void;
  replaceState(state: any, title: string, url?: string): void;
  location(): string;
}

export const routingMixins: RoutingMixin = {
  location(): string {
    return window.location.href.split("?")[0];
  },
  pushState(state: any, title: string, url?: string) {
    window.history.pushState(state, title, url);
  },
  replaceState(state: any, title: string, url?: string) {
    window.history.replaceState(state, title, url);
  },
};

export default {
  methods: routingMixins,
};
